import React from 'react';
import styles from './styles.scss';


const Loader = () => (
  <div className='text-center'>
    <p className='m-5'>
      <i className={`fa fa-spin fa-spinner ${styles.spinner}`}  />
    </p>
  </div>
);

export default Loader;


// WEBPACK FOOTER //
// src/components/shared/Loader/index.jsx